import React from "react";
import { useParams } from "react-router-dom";
import BundleThanksWrapperArea from "./BundleThanksWrapperArea";

function BundleThanks() {

  const { hash } = useParams(); // hash is the unique booking hash

  return (
    <>
      <BundleThanksWrapperArea hash={hash} />
    </>
  );
}

export default BundleThanks;
